import { useRef, useEffect, useState } from "react";
import { TestimonialsColumn } from "@/components/ui/testimonials-columns-1";

import AlainP from "@/assets/testimonials/Alain_P.jpg";
import CecileH from "@/assets/testimonials/Cecile_H.jpg";
import ThierryR from "@/assets/testimonials/Thierry_R.jpg";
import DoreneB from "@/assets/testimonials/Dorene_B.jpg";
import EtienneL from "@/assets/testimonials/Etienne_L.jpg";
import SachaH from "@/assets/testimonials/Sacha_H.jpg";
import KarimF from "@/assets/testimonials/Karim_F.jpg";
import YaelleP from "@/assets/testimonials/Yaelle_P.jpg";
import MaximeV from "@/assets/testimonials/Maxime_V.jpg";

const testimonials = [
  {
    text: "Petite anecdote marrante : l'autre jour je sors une vidéo sur un trek de fou en Patagonie, j'envoie ma notif à 20h et là bam en 30 minutes j'avais déjà genre 200 vues alors que d'habitude ça mettait 2-3h à décoller. C'est là que j'ai compris que cet outil c'était vraiment du sérieux. Mes abonnés les plus engagés ont maintenant ma carte dans leur wallet et dès que je poste ils sont prévenus instantanément, c'est trop cool franchement.",
    image: AlainP,
    name: "Alain P.",
    role: "Créateur de contenu YouTube",
  },
  {
    text: "Alors là je dois dire bravo !!! Ça fait 3 ans que je galère à remplir mes cours collectifs et depuis que j'utilise Unotif pour envoyer les rappels de séances c'est incroyable le taux de présence a carrément augmenté 🔥 Les gens reçoivent la notif direct sur leur écran de tel même verrouillé donc ils peuvent plus dire qu'ils ont pas vu mdrr. Et en plus mes clients adorent la carte dans leur wallet c'est stylé et pratique. Vraiment un super outil je recommande à fond !!",
    image: CecileH,
    name: "Cécile H.",
    role: "Coach fitness",
  },
  {
    text: "Bon bah moi qui suis pas du tout calé en techno j'ai réussi à créer ma carte fidélité en 10min chrono. Franchement chapeau parce que d'habitude je galère avec ces trucs là... Maintenant quand j'ai une promo ou une nouveauté hop je l'envoie direct à mes clients fidèles et ça marche vraiment bien ! Le seul truc c'est qu'il faut que les clients pensent à ajouter la carte au début mais après c'est que du bonheur 👌",
    image: ThierryR,
    name: "Thierry R.",
    role: "Propriétaire terrasse",
  },
  {
    text: "Waaaaah enfin un outil qui change vraiment la donne ! J'en avais marre que mes élèves ratent mes lives parce qu'ils voyaient pas mes emails (qui finissent TOUJOURS en spam soit dit en passant). Avec Unotif je les préviens 30min avant le live et maintenant j'ai facilement 80% de présents vs 30% avant c'est juste énorme comme différence !! En plus la carte dans le wallet fait très pro mes élèves adorent.",
    image: DoreneB,
    name: "Dorene B.",
    role: "Formatrice en ligne",
  },
  {
    text: "Plutôt satisfait de l'outil pour l'instant. On l'utilise surtout pour nos soirées à thème et nos offres du midi et ça marche plutôt bien. Les clients apprécient de recevoir les infos direct sur leur tel sans avoir à checker leurs mails. Par contre j'avoue qu'au début j'ai mis un peu de temps à comprendre comment bien configurer les notifications mais après ça roule. Le gros + c'est vraiment la simplicité pour les clients juste scanner le QR code et hop c'est dans leur wallet.",
    image: EtienneL,
    name: "Étienne L.",
    role: "Gérant restaurant",
  },
  {
    text: "Franchement parfait pour ma boutique de jeux rétro ! Dès que je reçois des consoles rares hop je notifie ma commu et c'est vendu en 2h chrono… Mes clients kiffent être prévenus en premier pour les drops. Ça m'a vraiment aidé à construire une base de fans ultra réactifs. Je recommande grave pour les boutiques de niche !!",
    image: SachaH,
    name: "Sacha H.",
    role: "Vendeur e-commerce",
  },
  {
    text: "Outil vraiment efficace et bien pensé. J'utilise Unotif depuis le lancement pour mes formations en ligne et le changement est significatif sur la présence aux webinaires. Avant avec les emails classiques j'avais beaucoup de no-show maintenant avec les notifications push directes sur wallet les taux de présence ont presque doublé. La mise en place est rapide, l'interface est claire et intuitive. Seul petit bémol les statistiques pourraient être un peu plus détaillées mais bon c'est vraiment pour chipoter.",
    image: KarimF,
    name: "Karim F.",
    role: "Formateur Excel & Data",
  },
  {
    text: "Depuis qu'on a activé les notifications géolocalisées sur nos 3 boutiques, on a vraiment beaucoup de clientes qui passent spontanément. Plusieurs nous ont dit \"j'étais dans le quartier, j'ai vu votre notification\" et ça c'est vraiment appréciable 💕 Maintenant on essaie de faire installer la carte au maximum de clientes parce que plus on en a, plus ça génère du passage en boutique logiquement. Ma collègue propose systématiquement la carte en caisse et ça marche super bien ! Un outil vraiment pratique pour développer notre clientèle.",
    image: YaelleP,
    name: "Yaëlle P.",
    role: "Gérante boutique mode",
  },
  {
    text: "Je dois dire que Unotif c'est exactement ce qu'il me fallait. J'avais essayé plein de canaux pour prévenir mes auditeurs des nouveaux épisodes : newsletter, posts Instagram, Twitter... Mais au final personne voyait rien ou alors trop tard. Maintenant avec la carte Wallet + les notifs push bah ils sont prévenus DIRECT quand je sors un nouvel épisode et boom les écoutes montent en flèche dès la première heure c'est dingueeee🔥 Je recommande à 100% !!",
    image: MaximeV,
    name: "Maxime V.",
    role: "Podcasteur",
  },
];

// Mobile (< md) : 1 colonne avec les 9 avis
const mobileColumn = testimonials;

// Tablet (md à lg) : 2 colonnes avec 4 + 5 avis
const tabletColumn1 = testimonials.slice(0, 4);
const tabletColumn2 = testimonials.slice(4, 9);

// Desktop (lg+) : 3 colonnes avec 3 + 3 + 3 avis (inchangé)
const desktopColumn1 = testimonials.slice(0, 3);
const desktopColumn2 = testimonials.slice(3, 6);
const desktopColumn3 = testimonials.slice(6, 9);

export const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || !contentRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, [isMounted]);

  return (
    <section
      id="temoignages"
      className="pt-16 sm:pt-20 lg:pt-24 pb-[50px] sm:pb-[62.5px] lg:pb-[75px] px-4 sm:px-6 lg:px-8 scroll-mt-20"
    >
      <div
        ref={contentRef}
        className={`max-w-5xl mx-auto transition-all duration-700 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
        }`}
      >
        {/* Header: exactement la même structure que InteractiveDemo */}
        <div className="text-center mb-8">
          {/* Badge top - mêmes classes que InteractiveDemo */}
          <div className="flex justify-center mb-6">
            <span className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#074155] bg-white text-sm font-semibold text-[#074155]">
              Témoignages
            </span>
          </div>

          {/* Titre H2 - mêmes classes que InteractiveDemo */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#074155] mb-4">
            Ce que nos utilisateurs disent :
          </h2>
        </div>

        {/* Colonnes de témoignages */}
        <div
          className="flex justify-center gap-6 mt-10 max-h-[600px] overflow-hidden"
          style={{
            maskImage:
              "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
          }}
        >
          {/* MOBILE ONLY (< md) : 1 colonne avec 9 avis */}
          <div className="block md:hidden">
            <TestimonialsColumn testimonials={mobileColumn} duration={40} />
          </div>

          {/* TABLET ONLY (md à lg) : 2 colonnes avec 4 + 5 avis */}
          <div className="hidden md:flex lg:hidden gap-6">
            <TestimonialsColumn testimonials={tabletColumn1} duration={18} />
            <TestimonialsColumn testimonials={tabletColumn2} duration={22} />
          </div>

          {/* DESKTOP ONLY (lg+) : 3 colonnes avec 3 + 3 + 3 avis (inchangé) */}
          <div className="hidden lg:flex gap-6">
            <TestimonialsColumn testimonials={desktopColumn1} duration={15} />
            <TestimonialsColumn testimonials={desktopColumn2} duration={18} />
            <TestimonialsColumn testimonials={desktopColumn3} duration={22} />
          </div>
        </div>
      </div>
    </section>
  );
};
